export function wfetch() {
    const response = {};

    return fetch(...arguments)
        .then((res) => {
            if (!res.ok) throw new Error(`Response status: ${res.status}`);

            response["url"] = res.url;
            response["status"] = res.status;

            return res.json();
        })
        .then((result) => {
            return {
                ...response,
                data: result,
            };
        });
}
